import * as angular from "angular";
import {ExpenseQueryRequest} from "../models/expense-query-request.model";
import {ExpensesExportQueryRequest} from "../models/expenses-export-query-request.model";

export class ExpensesRequests {

  constructor(private ExpensesApi, private $expenses) {
  }

  getOne(id) {
    const api = this.ExpensesApi.actions.getOne;
    return this.$$call(api, {}, {}, {id: id});
  }

  createExpense(expense) {
    const api = this.ExpensesApi.actions.createExpense;
    return this.$$call(api, {}, expense, {});
  }

  updateExpense(expense) {
    const api = this.ExpensesApi.actions.updateExpense;
    return this.$$call(api, {}, expense, {id: expense.id});
  }

  approveExpenses(expenseQueryRequest: ExpenseQueryRequest) {
    const api = this.ExpensesApi.actions.approveExpenses;

    return this.$$call(api, {}, expenseQueryRequest, {})
  }

  declineExpenses(expenseQueryRequest: ExpenseQueryRequest) {
    const api = this.ExpensesApi.actions.declineExpenses;

    return this.$$call(api, {}, expenseQueryRequest, {})
  }

  deleteExpenses(expenseIds: string[]) {
    const api = this.ExpensesApi.actions.deleteExpenses;

    return this.$$call(api, {expenseIds: expenseIds}, {}, {})
  }

  exportExpenses(expensesExportQueryRequest: ExpensesExportQueryRequest) {
    const api = this.ExpensesApi.actions.exportExpenses;

    return this.$$call(api, expensesExportQueryRequest, {}, {})
  }

  getExpenseTimeLine(expenseId: string, from?: number, to?: number) {
    const api = this.ExpensesApi.actions.getExpenseTimeLine;
    return this.$$call(api, {}, {}, {id: expenseId, from: from, to: to})
  }

  private $$call(_apiCall, _params, _data, _options) {
    return this.$expenses().$call(_apiCall, _params, _data, _options);
  }

  //_options = path params
  //_params = query params
}

angular
  .module('bringoz.admin.expenses')
  .service('expensesRequests', ExpensesRequests);

